require("utility/display_toggle_control.scss");

class DisplayToggleControl extends React.Component {
	constructor(props) {
		super();
		autobind(this);
	}

	buildToggleF(key) {
		return function(e) {
			$wr.nope(e)
			this.props.onChange(key);
		}.bind(this);
	}

	moveBar() {
		var $active = $(this.refs.box).find(".activeOp");
		var $bar = $(this.refs.bar);
		if ($active.length > 0 && $bar.length > 0) {
			$bar.css({ left: $active.position().left, width: $active.innerWidth() })
		}
	}

	mode() {
		return this.props.mode || BAR_MODE;
	}

	render() {
		var optionLinks = _.map(this.props.options, function(option) {
			var className = "toggleOp";
			if (option.key == this.props.activeOptionKey) {
				className += " activeOp";
			}
			
			if (option.newBadge) {
				var newBadge = <span className="badge">New!</span>
			}

			return (
				<a href="#" onClick={this.buildToggleF(option.key)}
					className={className} key={option.key}>
					{option.text}
					{newBadge}
				</a>
			);
		}.bind(this));

		var className = "displayToggleControl";
		if (this.props.className) {
			className += " " + this.props.className;
		}

		if (this.mode() === BAR_MODE) {
			var selectBar = (
				<div className="activeBar" ref="bar" />
			);

			className += " barMode";
		}

		if (this.mode() === LINK_MODE) {
			className += " linkMode";
		}

		return (
			<div className={ className } ref="box">
				{ optionLinks }
				{ selectBar }
			</div>
		);
	}

	componentDidMount() {
		this.moveBar();
	}

	componentDidUpdate() {
		this.moveBar();		
	}
};

var LINK_MODE = "link";
var BAR_MODE = "bar";

DisplayToggleControl.LINK_MODE = LINK_MODE;
DisplayToggleControl.BAR_MODE = BAR_MODE;

DisplayToggleControl.propTypes = StrictPropTypes({
	// array of hashes, e.g.: [{ key: "tree", text: "Class Tree" }, ...]
	options: PropTypes.array.isRequired,
	activeOptionKey: PropTypes.string,

	className: PropTypes.string,

	mode: PropTypes.string,

	// We'll pass the selected optionKey to this funciton
	onChange: PropTypes.func.isRequired
});

module.exports = DisplayToggleControl;



// WEBPACK FOOTER //
// ./modules/components/utility/DisplayToggleControl.js